/* Copyright (c) 2022 Xperi. All Rights Reserved. */

// TODO: We should remove the disbaled linters once we use these enums.
/* eslint-disable no-unused-vars */
/* eslint-disable no-shadow */
export enum VideoDataStreamLanguage {
    NOT_APPLICABLE,
    ENGLISH,
    SPANISH,
}
